import { useQuery } from "@tanstack/react-query";
import { ahr999ChartQueryOptions } from "@/services/queries/coinglass/coinglassQueries";

interface UseAHR999ChartParams {
  start_date?: string | undefined;
  end_date?: string | undefined;
  limit?: number | undefined;
}

export const useAHR999Chart = (params?: UseAHR999ChartParams) => {
  return useQuery(ahr999ChartQueryOptions(params));
};
